import { useQuery } from '@tanstack/react-query';

import { ActiveStayPeriod } from 'src/features/stay/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/visitors/active-stay/:stayId/active-stay-period/:periodId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    stayId: string;
    periodId: string;
    parkingId: string;
}
const queryFn = ({ stayId, periodId, parkingId, ...params }: DTO): Promise<ActiveStayPeriod> => {
    return axios.get(formatResourcePath(RESOURCE, { stayId, periodId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as ACTIVE_STAY_PERIOD_RESOURCE, useQueryHook as useGetActiveStayPeriod };
